export default function debug(...theArgs) {
  try {
    if (process.env.NODE_ENV === 'development') {
      window.console.log.apply(this, theArgs);
    }
  } catch (err) {
    /* empty */
  }
}
